export var appConfig = {
  insaServiceAddress: "https://client.amasus.ch/InsaWebApi/api",
  authServiceAddress: "https://client.amasus.ch/InsaWebApi",
  pivotViewerServiceAddress: "https://client.amasus.ch/Dashboard"
}



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Amadeus/insaweb.service.config.ts